import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { ITableHeaderProps, TableHeader } from "../../../../../../Shared/Table/Components/TableHeader";
import { PensionBase } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/PensionBase";
import { InvestmentAllocation } from "../../../../../../../Wrap/Models/Domains/Investment/InvestmentAllocation";
import { CheckboxEditor } from "../../../../../../../react-core/Html/CheckboxEditor";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { TableRow } from "../../../../../../Shared/Table/Components/TableRow";
import { ITableConfig } from "../../../../../../Shared/Table/Table";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { InvestmentsAction } from "../../../PortfolioDashboard/Components/Investment/Action/InvestmentAction";
import { Instrument } from "../../../../../../../Wrap/Models/Domains/Investment/Instrument";
import { SwitchInstructionModel } from "../../../../../../../Wrap/Models/Domains/Switch/SwitchInstructionModel";

export interface ISwitchInvestmentsTableProps{
    treassuredProductIds: number[],
    switchInvestmentsModel: SwitchInstructionModel
}

export interface ISwitchInvestmentsState{
    buyAllocations: InvestmentAllocation[],
    sellAllocations: InvestmentAllocation[]
}

export class SwitchInvestmentsTable extends React.Component<ISwitchInvestmentsTableProps, ISwitchInvestmentsState>{
    constructor(props){
        super(props);
        this.state ={
            buyAllocations: [],
            sellAllocations: []
        };
    }

    private switchInvestmentTableConfig(): ITableConfig[] {
        return [
            {
                title: "Name",
                key: "Instrument.Name",
                render: (data, row, index) => {
                    return row?.Name
                },
            },
            {
                title: "Allocation",
                key: "Instrument.Allocation",
                render: (data, row, index) => {
                    return row?.Percentage + "%"
                },
            },
            {
                title: "Protected from auto-disinvestment",
                key: "Instrument.Treasured",
                render: (data, row, index) => ""
            },
        ];
    }

    private renderTableRows(investmentAllocations: InvestmentAllocation[]){
        const col = this.switchInvestmentTableConfig();

        const rows = [];
        let rowIndex = 0;

        investmentAllocations?.forEach((allocation) => {
            rows.push(
                <TableRow
                    key={rowIndex}
                    data={allocation}
                    col={col.map((ele) => ({
                        title: ele.title,
                        key: ele.key,
                        render: (data, row, i) => {
                            if (ele.title === "Protected from auto-disinvestment") {
                                if (row.Type === ProductType.Cash) {
                                    return (
                                        <div style={{ display: 'inline-block', padding: '0 10px 0 20px', textAlign: 'center' }}>
                                            <span>N/A</span>
                                        </div>
                                    );
                                } else {
                                    return (
                                        <div style={{ paddingTop: '20px', paddingLeft: '20px' }}>
                                            <CheckboxEditor
                                                cssWrapper={"square-checkbox"}
                                                onChange={(v) => {}}
                                                value={this.props.treassuredProductIds?.includes(row.ProductId)}
                                                disabled
                                            />
                                        </div>
                                    );
                                }
                            }
                            
                            return ele.render(data, row, i);
                        },
                    }))}
                    index={rowIndex}
                />
            );
            rowIndex++;
        })

        return rows;
    }

    private getProductInfo(){
        const hierarchyId = getQueryParameters()["hierarchyid"];

        InvestmentsAction.getAllocationAssetDetails(
            hierarchyId,
            this.props.switchInvestmentsModel.BuyAllocations,
            this.props.switchInvestmentsModel.SellAllocations,
            (result: Instrument[], buyAllocations: InvestmentAllocation[], sellAllocations: InvestmentAllocation[]) => {
                const buys: InvestmentAllocation[] = buyAllocations?.map( (allocation) => {
                    const instrument: Instrument = result.find( (instrument) => instrument.ProductId === allocation.ProductId);
                    allocation.Name = instrument.Name;
                    allocation.Type = instrument.Type;
                    return allocation;
                });

                const sells: InvestmentAllocation[] = sellAllocations?.map( (allocation) => {
                    const instrument: Instrument = result.find( (instrument) => instrument.ProductId === allocation.ProductId);
                    allocation.Name = instrument.Name;
                    allocation.Type = instrument.Type;
                    return allocation;
                });

                this.setState({buyAllocations: buys, sellAllocations: sells});                    
            });
    }
    componentDidMount(): void {
        this.getProductInfo();
    }
    public render(): JSX.Element {
        const col = this.switchInvestmentTableConfig();
        
        return (
        <>
            <h3 className="mb-0">Switch From</h3>
            <table className={"data-table"}>
                <TableHeader col={col} />
                <tbody>
                    {this.renderTableRows(this.state.sellAllocations)}
                </tbody>
            </table>
            <h3 className="mb-0">Switch To</h3>
            <table className={"data-table"}>
                <TableHeader col={col} />
                <tbody>
                    {this.renderTableRows(this.state.buyAllocations)}
                </tbody>
            </table>
        </>);
    }
}